import HealingItem from './HealingItem.js';
import Pokeball from './Pokeball.js';
import MoveItem from './MoveItem.js';
import Item from './Item.js';
import HM from './HM.js';
import KeyItem from './KeyItem.js';
import HeldItem from './HeldItem.js';
import Berry from './Berry.js';
import Vitamin from './Vitamin.js';
import { getOSM } from '../OverworldAnimation.js';
import {
    pokeballItemIDs,
    keyItemIds,
    moveItemIDs,
    healingItemIDs,
    hmIds,
    heldItemIds,
    berryItemIds,
    vitaminItemIds,
    battleItemIds,
} from '../constants.js';
import { globalItemDataStore } from '../OverworldAnimation.js';

export default class ItemFactory {
    static create(itemId) {
        const itemData = globalItemDataStore[itemId];
        if (!itemData) {
            throw new Error(`Item with ID "${itemId}" not found in globalItemDataStore`);
        }
        itemData.stateMachine = getOSM();

        if (healingItemIDs.includes(itemId)) {
            return new HealingItem(itemData);
        } else if (pokeballItemIDs.includes(itemId)) {
            return new Pokeball(itemData);
        } else if (moveItemIDs.includes(itemId)) {
            return new MoveItem(itemData);
        } else if (hmIds.includes(itemId)) {
            return new HM(itemData);
        } else if (keyItemIds.includes(itemId)) {
            return new KeyItem(itemData);
        } else if (heldItemIds.includes(itemId)) {
            return new HeldItem(itemData);
        } else if (berryItemIds.includes(itemId)) {
            return new Berry({ id: itemId, ...itemData });
        } else if (vitaminItemIds.includes(itemId)) {
            return new Vitamin({ id: itemId, ...itemData });
        } else if (battleItemIds.includes(itemId)) {
            return new Item({ id: itemId, ...itemData });
        } else {
            console.warn(`Item with ID "${itemId}" does not belong to a known item type`);
            return new Item(itemData);
        }
    }
}
